// extracted by mini-css-extract-plugin
module.exports = {"icon":"student-delete_icon__2O4dX","description":"student-delete_description__2jnPy","buttons":"student-delete_buttons__fttra"};